export class IfcAlignmentData {
    constructor() {
        this.coordinates = new Float32Array(0);
        this.alignmentIndex = [];
        this.curveIndex = [];
    }
    exportData() {
        const { coordinates, alignmentIndex, curveIndex } = this;
        return { coordinates, alignmentIndex, curveIndex };
    }
}
//# sourceMappingURL=alignment.js.map